import React from "react";
import { Coins, Loader2 } from "lucide-react";
import { useGenerationCostEstimate } from "../../hooks/useGenerationCostEstimate";

const EstimatedPoints = ({ request, className = "", compact = false }) => {
  const { estimate, loading } = useGenerationCostEstimate(request);
  if (!request) return null;

  const available = Boolean(estimate?.available && Number(estimate?.estimatedPoints) > 0);
  const label = loading
    ? "预估中"
    : available
      ? `约 ${Number(estimate.estimatedPoints).toLocaleString("zh-CN")} 积分`
      : "积分待结算";
  const title = loading
    ? "正在估算本次生成所需积分"
    : `${estimate?.note || "最终以实际生成用量结算"}${available ? `，约 ¥${Number(estimate.estimatedCostCny || 0).toFixed(4)}` : ""}`;

  return (
    <span
      className={`inline-flex h-6 shrink-0 items-center gap-1 rounded-md border font-medium whitespace-nowrap ${compact ? "px-1.5 text-[9px]" : "px-2 text-[10px]"} ${className}`}
      style={{
        borderColor: "color-mix(in srgb, var(--color-accent-primary) 28%, var(--color-border-primary))",
        backgroundColor: "color-mix(in srgb, var(--color-accent-primary) 8%, var(--color-bg-card))",
        color: "var(--color-text-secondary)",
      }}
      title={title}
      aria-label={title}
    >
      {loading
        ? <Loader2 size={10} className="animate-spin" style={{ color: "var(--color-accent-primary)" }} />
        : <Coins size={10} style={{ color: "var(--color-accent-primary)" }} />}
      <span>{label}</span>
    </span>
  );
};

export default EstimatedPoints;
